import { createSelector } from "@reduxjs/toolkit";
import * as Immutable from "immutable";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectParameters } from "views/logic/slices/viewSelectors";
const selectParametersMap = createSelector(
  selectParameters,
  (parameters = Immutable.Set()) => Immutable.Map(parameters.map((p) => [p.name, p]))
);
const useParametersMap = () => useViewsSelector(selectParametersMap);
export default useParametersMap;
